import Grouping from './grouping';
import { formatCompletionTime } from '../utils';

export default class InteractiveCaseStudy extends Grouping {
  constructor(obj) {
    super(obj);
  }

  get contentTopicId() {
    return this.assetAssociations[1]?.assetBId;
  }

  get endTopicId() {
    return this.assetAssociations[2]?.assetBId;
  }

  get icon() {
    return 'helm';
  }

  get route() {
    return {
      name: 'interactiveCaseStudies#show',
      params: {
        groupingId: this.id,
      },
    };
  }

  get startTopicId() {
    return this.assetAssociations[0]?.assetBId;
  }

  cardMetadata() {
    if (this.completionTime) {
      return formatCompletionTime(this.completionTime);
    }
  }

  completedState(states) {
    // ICS groupings are made up of 3 topics, 3 states would be start, content, and end
    return Array.isArray(states) && states.length === 3;
  }

  inProgressState(states) {
    return Array.isArray(states) && states.length === 2;
  }

  states(store) {
    const topicIds = this.assetAssociations.map(aa => aa.assetBId);
    return topicIds.map(tid => store.getters['topicStates/topicStates'][tid]).filter(s => s);
  }
}